module.exports = __webpack_public_path__ + "assets/images/laranja_f006c6e55818cc1fda0e179d2aa14c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/esfera/laranja.png
// module id = 205
// module chunks = 0